import { Injectable } from '@angular/core';
import { Observable,Subject,BehaviorSubject } from "rxjs";

@Injectable({providedIn: 'root'})
export class FvmsMainCarService {
    /**
     * @param arg
     * arg.evtCode = "init.car"//초기차량목록
     * 
     * arg.evtCode = "search.car"//검색후 차량목록
     * 
     * arg.evtCode = "select.car.status"//차량상태 선택
     * 
     * arg.evtCode = "select.car.team"//그룹 선택
     * 
     * arg.evtCode = "select.car.item"//차량 아이템 선택
     * 
     * arg.evtCode = "auto.reload.car"//autoReload
     * 
     * arg.listCar = []//초기차량목록,검색후 차량목록,차량상태,그룹,autoReload
     * 
     * arg.selectedStatus = "all","on","off","error"//상태값
     * 
     * arg.selectedTeamId = ""//그룹id
     * 
     * arg.selectedCar = {}//차량 아이템
     */
    public subjCarFromMainMap:Subject<any> = new Subject<any>();
    public subjCarFromSidebar:Subject<any> = new Subject<any>();
}